/**
 * Internal dependencies
 */
import SearchFilterTitle from 'src/components/common/search/searchFilterTitle';

const TITLE_NAME = 'Skill';

const SkillFilterTitle = ({ selectList }) => (
  <SearchFilterTitle title={TITLE_NAME} selectList={selectList} />
);

export default SkillFilterTitle;
